import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, RequiredMark } from "@components/inputs/shared";

const ReactMarkdown = React.lazy(() => import("react-markdown"));

export default function OnboardingRegistrationConditions() {
	const { t } = useTranslation("registration");

	return (
		<div className="form__group u-mar--bottom--reset">
			<div className="label label--strong u-type--sml">
				{t("TERMS_CONDITIONS_LABEL")}
				<RequiredMark required />
			</div>

			<CheckboxInput
				id="termsAndPrivacyCheckbox"
				name="acceptTermsAndConditions"
			/>
		</div>
	);
}

function CheckboxInput(props: { id: string; name: string }) {
	const { name, id } = props;

	const { t } = useTranslation("registration");
	const { register } = useFormContext();

	const field = register(name, {
		required: {
			value: true,
			message: "COMMON.REQUIRED_FIELD",
		},
	});

	return (
		<div>
			<ErrorMessage name={name} />

			<div className="input--check input--check--sml">
				<input
					type="checkbox"
					id={id}
					className="input--check__box input--check--sml__box"
					{...field}
				/>

				<label
					htmlFor={id}
					className="input--check__label input--check--sml__label"
				>
					<ReactMarkdown
						linkTarget={"_blank"}
						className="u-anchor--nested"
					>
						{t("TERMS_CONDITIONS")}
					</ReactMarkdown>
				</label>
			</div>
		</div>
	);
}
